// extracted by mini-css-extract-plugin
module.exports = {"coontainer":"regCompleted_coontainer__1msCd"};